import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f387c3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "promotion" }
const _hoisted_2 = { style: {"margin-top":"10px","margin-bottom":"10px","width":"360px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { style: {"margin-top":"10px","margin-bottom":"10px","width":"360px"} }
const _hoisted_5 = { style: {"margin":"10px"} }
const _hoisted_6 = { class: "rank" }
const _hoisted_7 = { class: "rank-title" }
const _hoisted_8 = { class: "rank-date" }
const _hoisted_9 = { style: {"width":"100%"} }
const _hoisted_10 = { style: {"width":"100%"} }
const _hoisted_11 = { class: "rank" }
const _hoisted_12 = { class: "rank-title" }
const _hoisted_13 = { class: "rank-date" }

import BaseEchart from '@/components/BaseEchart.vue'
import {
  statisticDay,
  statisticOnlineNumber
} from '@/service/main/live/statitiscal'
import { ref } from 'vue'
import {
  getLiveOption,
  getOnlineNumberOption,
  getRankOption
} from './config/chart'
import { yesterday } from '@/utils/date-format'
import { dayTop } from '@/service/common/common'
import { useStore } from '@/store'

// 直播图

export default /*#__PURE__*/_defineComponent({
  __name: 'Promotion',
  setup(__props) {

const liveOption = ref<any>({})
const onlineNumberOption = ref<any>({})

const channelId = ref<string>('0')

const channel = ref<any[]>([
  {
    value: '0',
    label: '全部'
  },
  {
    value: '2',
    label: '内 部 专 享'
  },
  {
    value: '3',
    label: '与牛共舞666'
  },
  {
    value: '9',
    label: '与牛共舞0909'
  }
])

const getLiveStatistic = async (channelId: number) => {
  const data = await statisticDay(channelId)
  liveOption.value = getLiveOption(data)
}
getLiveStatistic(0)

const getOnlineNumberStatistic = async (channelId: number) => {
  const data = await statisticOnlineNumber(channelId)
  onlineNumberOption.value = getOnlineNumberOption(data)
}
getOnlineNumberStatistic(3)

const selectChange = (val: string) => {
  getLiveStatistic(parseInt(val))
}
const onlineNumberSelectChange = (val: string) => {
  getOnlineNumberStatistic(parseInt(val))
}

const store = useStore()
const handleExportClick = async () => {
  await store.dispatch('system/exportXlsx')
}

// 排行榜
// 复播标签值
const activeTab = ref('count')

const fbCountOption = ref<any>({})
const fbSumOption = ref<any>({})
const promotionCountOption = ref<any>({})

const getDayTop = async (type: number, url: string) => {
  const data = await dayTop(url, type % 3)
  if (type == 1) {
    fbCountOption.value = getRankOption(data, '客户数量')
  }

  if (type == 2) {
    fbSumOption.value = getRankOption(data, '听课时长')
  }

  if (type == 4) {
    promotionCountOption.value = getRankOption(data, '客户数量')
  }
}

getDayTop(1, '/fubo/statistic/dayTop')
getDayTop(2, '/fubo/statistic/dayTop')
getDayTop(4, '/promotion/statistic/dayTop')

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  "label-width": "120px",
                  style: {"width":"440px"},
                  inline: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "直播间" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: channelId.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((channelId).value = $event)),
                          onChange: selectChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channel.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-download",
                      onClick: handleExportClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 导出数据 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(BaseEchart, {
                  options: liveOption.value,
                  height: "720px"
                }, null, 8, ["options"])
              ])
            ]),
            _hoisted_3,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form, {
                  "label-width": "120px",
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "直播间：" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 与牛共舞666 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(BaseEchart, {
                  options: onlineNumberOption.value,
                  height: "720px"
                }, null, 8, ["options"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createTextVNode(" 复播排行榜   "),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(yesterday)()), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_tabs, {
                    modelValue: activeTab.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tab_pane, {
                        label: "观看人数",
                        name: "count",
                        lazy: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(BaseEchart, {
                              options: fbCountOption.value,
                              height: "360px"
                            }, null, 8, ["options"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_tab_pane, {
                        label: "观看时长",
                        name: "sum",
                        lazy: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(BaseEchart, {
                              options: fbSumOption.value,
                              width: "100%",
                              height: "360px"
                            }, null, 8, ["options"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, [
                    _createTextVNode(" 素材排行榜   "),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(yesterday)()), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(BaseEchart, {
                    options: promotionCountOption.value,
                    height: "360px"
                  }, null, 8, ["options"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})